import React from 'react';
import ProductCard from './ProductCard';
import '../styles/ProductGrid.css';

const ProductGrid = ({ products, loading, onSelectProduct, onOpenLightbox }) => {
  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Cargando productos...</p>
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="no-products">
        <p>No se encontraron productos</p>
      </div>
    );
  }

  return (
    <div className="product-grid">
      {products.map(product => (
        <ProductCard 
          key={product.codigo} 
          product={product}
          onSelectProduct={onSelectProduct}
          onOpenLightbox={onOpenLightbox}
        />
      ))}
    </div>
  );
};

export default ProductGrid;